import { AdministrativeSection } from '@core/_config/menu/tenant/administrative.section';
import { FinanceSection } from '@core/_config/menu/tenant/finance.section';
import { AccountSection } from '@core/_config/menu/tenant/accounting.section';
import { ConfigurationSection } from '@core/_config/menu/tenant/configuration.section';
import { CommonPerm } from '@enum/common/permission/common-perm.enum';

export const TenantMenu = [
  {
    title: 'Início',
    root: true,
    icon: 'home',
    page: '/painel/dashboard',
    bullet: 'dot',
  },

  // O item "Certificado digital" com destaque de oferta SAIU do menu (dono,
  // 22/09/2026: reversão parcial da decisão de 21/09) — *"me incomodou o
  // destaque, para algo que será feito 1 vez por ano"*. A ação de contratar
  // virou secundária em Configurações › Nota fiscal (`configure.component`) e
  // aparece no bloqueio de emissão sem certificado (`generate-fiscal-note`).
  // A ROTA `/painel/certificado-digital` continua existindo (link do alerta
  // do dashboard e e-mails antigos) — só o item fixo do menu foi removido.
  ...AdministrativeSection,
  ...FinanceSection,
  ...AccountSection,
  ...ConfigurationSection,

  {
    section: 'Histórico',
    permission: ['*', CommonPerm.Logs_View],
  },
  {
    title: 'Ações',
    permission: ['*', CommonPerm.Logs_View],
    root: true,
    icon: 'menu_book',
    bullet: 'dot',
    page: '/painel/historicos/acoes',
  },
];
